import React, { Component } from 'react';
import { Dropdown } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  saveAccountOperationStatus,
  saveAccountOperationStatusInFrontEnd
} from '../../actions/settings/index';

class ListColumnBtn extends Component {
  constructor(props) {
    super(props);

    this.updateTable = this.updateTable.bind(this);

    //init filter state
    this.state = {
      refTable: null,
      visibleColumns: []
    }

    // set this to ref
    if (props.refs) {
      props.refs(this);
    }
  }

  updateTable() {
    let refTable = (this.props.refTable) ? this.props.refTable : null;
    this.setState({
      refTable: refTable
    });
  }

  initVisibleColumns = () => {
    const {authToken ,tableId, visibleColumnsConfig ,saveAccountOperationStatus,  refTable } = this.props;
    const {accountOperationStatusList} = this.props;
    let accountOperationStatus = {}

    if(accountOperationStatus === null){
      accountOperationStatus = {};
    }
    // If data of this table is empty, create the default table structure. and save it
    if( !accountOperationStatusList.hasOwnProperty(tableId)){


      refTable.options.columns.forEach(defaultColumn => {
        accountOperationStatus[defaultColumn.field] = defaultColumn.visible === false ? false: true;
      })
      accountOperationStatusList[tableId] = accountOperationStatus;
      
      // save new account operation status in front end  , save in sever , save in seassion 
      saveAccountOperationStatusInFrontEnd(accountOperationStatusList);
      saveAccountOperationStatus(authToken ,tableId, accountOperationStatus);
      window.sessionStorage.setItem(window.CONFIG.PROJECT_ID + window.CONFIG.WEB_CACHE_KEY.ACCOUNT_OPERATION_STATUS,JSON.stringify(accountOperationStatusList));

    } else{
       // if exit data of this table =>  use this table structure.
      accountOperationStatus = accountOperationStatusList[tableId];
      // console.log("sads",accountOperationStatus)
      let newColumns = []
      refTable.options.columns.forEach(defaultColumn => {
        const newDefaultColumn = defaultColumn;
        newDefaultColumn.visible = accountOperationStatus[defaultColumn.field];
        newColumns.push(newDefaultColumn);
      })
      refTable.setColumns(newColumns);
    }
      
    let newVisibleColumns = [];
    if (refTable.options.columns && refTable.options.columns.length > 0) {  
      visibleColumnsConfig.columns.forEach(visibleColumn => {
        visibleColumn.checked = accountOperationStatus[visibleColumn.field];
        newVisibleColumns.push(visibleColumn);
      });


      this.setState({
        visibleColumns:newVisibleColumns
      });
    }
  }

  renderVisibleColumns = (tableId) => {
    const { visibleColumnsConfig } = this.props;
    if (visibleColumnsConfig) {
      const filterOptions = this.renderVisibleColumnOptions(tableId);
      return (
        <div className='area-visible-columns'>
          <div className='dropdown-tip'>{visibleColumnsConfig.title}</div>
          { filterOptions }
        </div>
      );
    } else {
      return (
        <div className='no-quick-filters'></div>
      );
    }    
  }

  renderVisibleColumnOptions = (tableId) => {
    const { visibleColumns } = this.state;
    return visibleColumns.map((item, index) => {
      let dropdownClass = 'select-item';
      if (item.visible === false) {
        dropdownClass = 'no-display';
      }

      let classChecked = 'icon-btn-checkbox-n';
      if (item.checked) {
        classChecked = 'icon-btn-checkbox-p';
      }

      const itemName = item.name ? item.name : item.field;

      return (
        <Dropdown.Item key={index} onClick={(e) => this.selectVisibleColumnItem(e, item)} className={dropdownClass}>
          <span className='check-icon-area'>
            <span id={tableId + '-' + itemName + '-' + item.field} className={classChecked}/>
          </span>
          <span className='check-text'>{item.title}</span>
        </Dropdown.Item>
      );
    });
  }

  selectVisibleColumnItem = (e, item, state) => {
    const { tableId, refTable  , authToken ,accountOperationStatusList, saveAccountOperationStatus   , saveAccountOperationStatusInFrontEnd } = this.props;
    const { visibleColumns } = this.state;
    const itemName = item.name ? item.name : item.field;
    const itemField = item.field;

    accountOperationStatusList[tableId][itemField]  = accountOperationStatusList[tableId][itemField] ?  false : true; 

    // save new account operation status in front end (dispath) , save in sever , save in seassion 
    saveAccountOperationStatusInFrontEnd(accountOperationStatusList);
    saveAccountOperationStatus(authToken ,tableId, accountOperationStatusList[tableId])
    window.sessionStorage.setItem(window.CONFIG.PROJECT_ID + window.CONFIG.WEB_CACHE_KEY.ACCOUNT_OPERATION_STATUS,JSON.stringify(accountOperationStatusList));

    
     //checked the Dropdown Menu Option
    let elChecked = document.getElementById(tableId + '-' + itemName + '-' + item.field);
    let classTarget = elChecked.className;
    const doCheck = classTarget === 'icon-btn-checkbox-n';
    const classCheck = doCheck ? 'icon-btn-checkbox-p' : 'icon-btn-checkbox-n';
    elChecked.className = classCheck;
    // fix visibleColumns value
    visibleColumns.forEach(visibleColumn => {
      if (visibleColumn.name === itemName || visibleColumn.field === itemName) {
        visibleColumn.checked = doCheck;
      }
    });

    // combine the columns with visible
    let newColumns = [];
    refTable.options.columns.forEach(defaultColumn => {
      if (defaultColumn.title) {
        visibleColumns.forEach(visibleColumn => {
          if (visibleColumn.field === defaultColumn.field) {
            let newColumn = defaultColumn;
            newColumn.visible = visibleColumn.checked;
            newColumns.push(newColumn);
          }
        });
      } else {
        // it's button columns, always display
        newColumns.push(defaultColumn);
      }
    });

    if (refTable) {
      refTable.setColumns(newColumns);
    }

    this.setState({
      visibleColumns: visibleColumns      
    });
  }

  componentDidMount() {
    // if call render will do this method
    this.updateTable();

    // this.initVisibleColumns();
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    // if props change will call this method
    if (prevProps.refTable !== this.props.refTable) {
      this.updateTable();
      this.initVisibleColumns();
    }
  }

  render() {
    const { tableId } = this.props;
    const renderVisibleColumnsOption = this.renderVisibleColumns(tableId);
    return (
      <span className='adjust-visible-columns-area' title='visible columns'>
        <Dropdown>
          <Dropdown.Toggle id={tableId + "ListColumnBtn"} className='dropdown-toggle'>
            <div className='area-column-btn'>
                <div className='area-icon'><span id="column-button" className='btn-icon'></span></div>
                <div className='area-text'>Column Options</div>
            </div>
          </Dropdown.Toggle>
          <Dropdown.Menu id={tableId + "ListSettingMenu"} flip={true}>
          { renderVisibleColumnsOption }
          </Dropdown.Menu>
        </Dropdown>
      </span>
    )
  }
}

const mapStateToProps  = (state,ownProps) => {

  
  return {
    authToken: state.loginReducers.authToken,
    accountOperationStatusList: state.settingsReducers.accountOperationStatusList
  }
}

export default withRouter(connect(
  mapStateToProps,
  {saveAccountOperationStatus ,  saveAccountOperationStatusInFrontEnd}
)(ListColumnBtn))